(() => {
  const targetId = 'QuestionnaireForm';
  const buttonId = 'js-submit-button';
  const target = document.getElementById(targetId);
  const $target = $(`#${targetId} :input`);
  const button = document.getElementById(buttonId);

  const googleAppsScriptUrl =
    'https://script.google.com/macros/s/AKfycbzwbX3LgKv97d2j4Z00-gZKgHttOd_0GS1Vc5EBEiWXgIt9th3Q9l_aLxoo2oc97e5h/exec';

  /**
   * @param {array} formArray [{name: 'name', value: 'value'}]
   * @return {object}  {'name': 'value'}
   */
  const objectifyForm = (formArray) => {
    const returnObject = {};
    for (let i = 0; i < formArray.length; i++) {
      returnObject[formArray[i]['name']] = formArray[i]['value'];
    }
    return returnObject;
  };

  const getRedirectUrl = () => {
    const url = location.href;
    const urlParam = location.search.substring(1);
    if (!urlParam) {
      return `${url}?contact_posted=true`;
    }
    if (!urlParam.match(/contact_posted=true/)) {
      return `${url}&contact_posted=true`;
    }
    return url;
  }

  const redirect = (url) => {
    location.href = url;
  };

  window.addEventListener('DOMContentLoaded', () => {
    if (!target) {
      return;
    }
    target.addEventListener('submit', (event) => {
      event.preventDefault();
      button.disabled = true;
      console.log($target.serializeArray())
      const formObject = objectifyForm($target.serializeArray());
      const postParameter = {
        method: 'POST',
        mode: 'no-cors',
        'Content-Type': 'text/plain',
        body: JSON.stringify(formObject),
      };
      fetch(googleAppsScriptUrl, postParameter).finally(() => {
        redirect(getRedirectUrl());
      });
    });
  })
})();
